import { Settings2 } from 'lucide-react';
import React from 'react';
import { Button } from '@/components/ui/button';

export interface TableSettingsButtonProps {
  onClick: () => void;
  className?: string;
}

/**
 * Opens the table column settings modal. Shown next to export in the toolbar.
 */
export const TableSettingsButton: React.FC<TableSettingsButtonProps> = ({
  onClick,
  className,
}) => (
  <Button
    type="button"
    variant="outline"
    size="sm"
    onClick={onClick}
    title="Tabelle konfigurieren"
    aria-label="Tabelle konfigurieren"
    className={className}
  >
    <Settings2 className="h-4 w-4 shrink-0" />
    Tabelle konfigurieren
  </Button>
);
